import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import OidcCallback from './views/OidcCallback.vue'
// import OidcPopupCallback from './views/OidcPopupCallback.vue'
import OidcCallbackError from './views/OidcCallbackError.vue'
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/change-password',
      name: 'changePassword',
      component: () => import(/* webpackChunkName: "protected" */ './views/ChangePassword.vue')
    },
    {
      path: '/edit-profile',
      name: 'editProfile',
      component: () => import(/* webpackChunkName: "protected" */ './views/EditProfile.vue')
    },
    {
      path: '/oauth-callback', // Needs to match redirectUri in you oidcSettings
      name: 'oidcCallback',
      component: OidcCallback
    },
    // {
    //   path: '/oauth-popup-callback', // Needs to match popupRedirectUri in you oidcSettings
    //   name: 'oidcPopupCallback',
    //   component: OidcPopupCallback
    // },
    {
      path: '/oauth-callback-error', // Needs to match redirect_uri in you oidcSettings
      name: 'oidcCallbackError',
      component: OidcCallbackError,
      meta: {
        isPublic: true
      }
    }
  ]
})

router.beforeEach(vuexOidcCreateRouterMiddleware(store, 'oidcStore'))

export default router
